import React from "react";
import { BookOpen, TrendingUp, Globe, Rocket } from "lucide-react";
import { motion } from "framer-motion";

const InvestHeroSection = () => {
  return (
    <section className="relative overflow-hidden py-16 px-4 md:px-10">
      {/* Background Image Container */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/assets/invest/background-image.jpg')"
          }}
        >
          {/* Gradient overlay for smooth transition from dark to light */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent"></div>
          
          {/* Additional blur overlay on left side for better text readability */}
          <div className="absolute left-0 top-0 bottom-0 w-1/2 bg-gradient-to-r from-black/40 to-black/10 backdrop-blur-[1px]"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center relative z-10">
        {/* Left Text Content */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white"
        >
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4">
            Invest in the Future of Reading
          </h1>
          <p className="text-lg mb-6">
            Be a part of India's reading revolution with{" "}
            <span className="font-semibold">BooksAtDoorsteps.com</span> — where we're delivering knowledge, dreams, and opportunities across India, from metros to rural villages.
          </p>

          <ul className="space-y-2 text-base font-medium">
            <li className="flex items-center gap-2">
              <TrendingUp className="text-green-400" size={20} />
              Proven Subscription Model & Steady Revenue
            </li>
            <li className="flex items-center gap-2">
              <Rocket className="text-purple-400" size={20} />
              Scalable Logistics & Tech Stack
            </li>
            <li className="flex items-center gap-2">
              <Globe className="text-blue-400" size={20} />
              Pan-India Social Impact
            </li>
            <li className="flex items-center gap-2">
              <BookOpen className="text-yellow-400" size={20} />
              Over 1 Lakh Curated Books
            </li>
          </ul>

          <div className="mt-8">
            <a
              href="#investor-form"
              className="inline-block bg-primary text-white px-6 py-3 rounded-2xl text-lg font-semibold hover:bg-secondary transition"
            >
              Start Investing Today
            </a>
          </div>
        </motion.div>

        {/* Right side - Empty but maintains layout */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="hidden md:block"
        >
          {/* This space is intentionally left empty to show the background image */}
        </motion.div>
      </div>
    </section>
  );
};

export default InvestHeroSection;